// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "bootstrap";
import BootstrapVue from "bootstrap-vue";
import Treeselect from "@riophae/vue-treeselect";

import "flatpickr/dist/themes/material_blue.css";
import "material-design-icons/iconfont/material-icons.css";
import "typeface-roboto/index.css";

import "animate.css/animate.min.css";

import "snackbarjs";

import App from "./App";
import router from "./router";
import globals from "./globals";
import feature from "./feature";
import store from "./store";

// Import JS services
import appService from "./services/app.service";
Object.defineProperty(Vue.prototype, "$appService", {
  value: appService,
});

import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

Vue.use(BootstrapVue);
Vue.component("treeselect", Treeselect);

try {
  // Send access token to service worker if requested.
  const authChannel = new BroadcastChannel("authChannel");

  authChannel.onmessage = (event) => {
    if (event.data === "getAuthTokenHeader") {
      authChannel.postMessage({
        authTokenHeader: `Bearer ${appService.getAccessToken()}`,
      });
    }
  };
} catch (e) {
  this.globals.showErrorSnackbar(
    "Your browser does not support all used functionality for this webapplication."
  );
}

Vue.config.productionTip = false;

Vue.prototype.globals = globals;
Vue.prototype.feature = feature;

router.beforeEach((to, from, next) => {
  if (
    to.name === "DirectToLoginCallback" ||
    to.name === "DirectToLogoutCallback"
  ) {
    appService.redirectAfterLoginCallback();
    return;
  }

  if (!appService.isUserAuthenticated()) {
    appService.renewToken();
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js